import React from "react";
import { FormOptionGroup } from "mesh-component-library";
import { useLocale } from "../../contexts/LocaleContext";
import { TRANSLATION_CONSTANTS } from "../../app-consts/translations";

type ReplacementRentalCar = {
  onChange: (e: React.FormEvent<HTMLFieldSetElement>) => void;
  response: string;
};

export const ReplacementRentalCar = ({ onChange, response }: ReplacementRentalCar) => {
  const getTranslatedText = useLocale();
  
  return (
    <FormOptionGroup
      label= {getTranslatedText(TRANSLATION_CONSTANTS.REPLACEMENT_RENTAL_QUESTION)}
      onChange={onChange}
      options={[
        {
          id: "replacement-option-1",
          name: "replacement-options",
          text: "Yes",
          value: "Yes",
          defaultChecked: "Yes" === response,
        },
        {
          id: "replacement-option-2",
          name: "replacement-options",
          text: getTranslatedText(TRANSLATION_CONSTANTS.NO_END_MY_RENTAL),
          value: getTranslatedText(TRANSLATION_CONSTANTS.NO_END_MY_RENTAL),
          defaultChecked: getTranslatedText(TRANSLATION_CONSTANTS.NO_END_MY_RENTAL) === response,
        },
      ]}
      type="radio"
      required={true}
    />
  )
};